import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";
import { omitBy } from "lodash";

export const getDropShipping = (params) => (dispatch, getState) => {
    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();
    return axios
        .get(`/api/product-drop/?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getDropShippingCategory = () => (dispatch, getState) => {
    return axios
        .get(`/api/product-drop/category`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getXffbbWarehouses = () => (dispatch, getState) => {
    return axios
        .post(`/api/partner-drop/store/list`, {}, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const getShippingOpt = (params) => (dispatch, getState) => {
    if (!params?.sku) return;
    const p = omitBy(params, (value) => !Boolean(value));
    const paramsUrl = new URLSearchParams(p).toString();
    return axios
        .get(`/api/product-drop/shipping-options?${paramsUrl}`, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const callFavorite = (body) => (dispatch, getState) => {
    return axios
        .post(`/api/product-drop/favorite`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const addSystems = (body) => (dispatch, getState) => {
    return axios
        .post(`/api/product-drop/add-system`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success")
                return res.data.data;
            } else {
                Swal.fire(t("Error"), t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const orderRate = (body) => (dispatch, getState) => {
    return axios
        .post(`/api/partner-drop/order/rate`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success")
                return res.data.data;
            } else {
                Swal.fire("Error", t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};

export const orderCreate = (body) => (dispatch, getState) => {
    return axios
        .post(`/api/partner-drop/order/create`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.status === 200) {
                Swal.fire(t("Success"), t(res.data.message), "success")
                return res.data.data;
            } else {
                Swal.fire("Error", t(res.data.message), "error");
            }
        })
        .catch((err) => {
            Swal.fire(t("Error"), t("An error occurred!"), "error");
        });
};
